import CircularProgress from "@mui/material/CircularProgress";

const AgGridLoader = (props) => {
  return (
    <div
      className="ag-custom-loading-cell"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        fontSize: "16px",
        fontWeight: "bold",
      }}
    >
      <CircularProgress
        size={40}
        style={{ marginBottom: "10px", color: "#1976d2" }}
      />
      {props.loadingMessage || "Loading..."}
    </div>
  );
};

export default AgGridLoader;
